AoPS.Utils.initKeyChain(AoPS, "Ebooks");

AoPS.refreshOnBackButtonLoadWithOldData("ebooks");

AoPS.Ebooks = (function (Ebooks) {
	// Dependencies
	var Page = AoPS.Page;
	var Modal = AoPS.Ui.Modal;
	var Feed = AoPS.Feed; // Optional
	var bootstrap_data = AoPS.bootstrap_data || {};

	var EbkModels = AoPS.Ebooks.Models; // .Master
	var EbkBookCtrl = AoPS.Ebooks.BookController;
	var EbkVIndex = AoPS.Ebooks.Views.Index;
	var EbkVBook = AoPS.Ebooks.Views.Book;
	var EbkUrlMain = AoPS.Ebooks.Url.main;

	// Optional and allowed to load before or after this file
	// AoPS.Ebooks.Admin;

	// Set to true for pretty URLs, false for hash-based URLs. All the needed
	// changes to make either work are propagated by setting this variable.
	var USE_PUSH_STATE = true;

	// Generic function for transforming all hrefs inside a jquery element into
	// the one output by the provided function.
	function mangleHrefs($el, mangleFunc) {
		$el.find("a[href]").each(function () {
			$(this).attr("href", mangleFunc($(this).attr("href")));
		});
	}

	// Relative sidebar links need to be directed to the store
	function computeSidebarHref(orig_href) {
		if (orig_href[0] === "/") {
			return orig_href;
		} else {
			return "/store/" + orig_href;
		}
	}

	Ebooks.Router = Backbone.Router.extend({
		// We don't use Backbone's routes hash because Javascript objects aren't
		// ordered and Backbone is stupid for treating them as though they are.
		// Instead, we use an array of objects. An extra setup step in the
		// initialize method is required as a result.
		// url is the usual route URL pattern, f is the route function to call.
		route_data: [
			{
				// The 404 route must be first in this array so that it is matched last.
				url: "*notfound",
				f: "route404",
			},
			{
				url: EbkUrlMain.getUrlPattern("index", true),
				f: "routeIndex",
			},
			{
				url: EbkUrlMain.getUrlPattern("book_notrail", true),
				f: "routeBook",
			},
			{
				url: EbkUrlMain.getUrlPattern("book", true),
				f: "routeBook",
			},
			{
				url: EbkUrlMain.getUrlPattern("book_preview", true),
				f: "routeBookPreview",
			},
			{
				url: EbkUrlMain.getUrlPattern("edge", true),
				f: "routeEdge",
			},
		],

		initialize: function () {
			this.page = new Page.constructPage("ebk-page");

			// Create master model using bootstrapped data, if any.
			this.master_model = new EbkModels.Master({
				user_id: bootstrap_data.ebk_user_id,
				is_admin: bootstrap_data.ebk_is_admin,
			});
			if (bootstrap_data.ebk_init_data) {
				this.master_model.unpack(bootstrap_data.ebk_init_data);
			}

			this.book_controllers = {};

			// Set up the sidebar, which initially starts in some arbitrary place
			// on the page hidden by CSS.
			mangleHrefs($("#side-column-wrapper"), computeSidebarHref);
			this.store_sidebar_el = {
				id: "ebk-store-sidebar",
				type: "jQuery_object",
				location: "ebk-loc-sidebar",
				jQuery_object: $("#side-column-wrapper"),
			};
			$("#side-column-wrapper").detach();

			// route_data setup
			_.each(
				this.route_data,
				function (route_node) {
					var url = route_node.url;
					this.route(url, route_node.f);
					if (url.indexOf("*") < 0 && url.slice(-1) !== "/") {
						this.route(url + "/", route_node.f);
					}
				},
				this
			);
			// Feed route
			if (Feed) {
				this.route(/^feed\/[0-9]+\/ebooks(.*)/, Feed.onFeedRoute);
			}

			// Event for manually hopping to a section, sparing some URL computations.
			// The book must be the model.
			// The section can either be the model or the ID.
			// The third parameter is an optional object with paragraph_id or label_id keys.
			this.listenTo(
				Backbone,
				"ebk_goto_section",
				function (book, section_id, details) {
					var book_ctrl = this.getOrCreateBookCtrl(book.id);
					var url = book_ctrl.getUrl(section_id, details);
					var sku = book.get("store_sku");
					if (url) {
						this.routeBook(sku, url, details);
						this.navigateRoot(EbkUrlMain.getUrl("book", sku, url), {
							trigger: false,
						});
					}
				}
			);
		},

		// Wrapper around this.navigate which detects and strips the root URL
		// if present before forwarding the call.
		navigateRoot: function () {
			var args = _.toArray(arguments);
			args[0] = args[0] || "";
			var match = args[0].match(
				new RegExp(".*" + EbkUrlMain.getRoot() + "(.*)")
			);
			args[0] = match ? match[1] : args[0];
			return this.navigate.apply(this, args);
		},

		startHistory: function (use_push_state) {
			// Don't display anything until the current user has loaded.
			this.master_model.requestLoad(function (ok, data) {
				if (!ok) {
					data.zero_load = true;
					return this.routeError(data);
				}

				// Parameters to pass to Backbone.history.start
				var start_params;

				if (use_push_state) {
					start_params = {
						pushState: true,
						root: EbkUrlMain.getRoot(),
					};
				} else {
					start_params = {};
					// When not using push state, all URLs computed using EbkUrlMain need
					// to have a root of #.
					EbkUrlMain.setRoot("#");
				}

				// Needed for feed
				AoPS.router_root = EbkUrlMain.getRoot().substr(1);
				AoPS.pushState_attr = "data-ebk-stay";
				Feed && Feed.constructFeed();

				// A link with the custom data-ebk-stay attribute is intended to stay on the
				// page and not reload. We hijack all such links here.
				$(document).on(
					"click",
					"a[href][data-ebk-stay]",
					_.bind(function (evt) {
						evt.preventDefault();
						// Clicking a link in a modal should close that modal.
						Modal.closeAllModals();
						// An a href contains the URL root so that new-tab clicks work.
						// But we have to strip it off.
						this.navigateRoot($(evt.currentTarget).attr("href"), {
							trigger: true,
						});
					}, this)
				);

				// Server routing issues sometimes mean we get an m/ in the URL that
				// shouldn't be there. Strip it out manually if it's there.
				if (window.location.href.match("/m/ebooks")) {
					window.history.replaceState(
						{},
						document.title,
						location.href.replace("/m/ebooks", "/ebooks")
					);
				}

				// If the user's first URL is the error route, they probably refreshed
				// and are not expecting to see the error page again.
				if (window.location.href.match(/error$/)) {
					// Don't let Backbone.history.start parse the current URL.
					// But we do need to call start before using navigate.
					start_params.silent = true;
					Backbone.history.start(start_params);
					this.navigateRoot(EbkUrlMain.getUrl("index"), {
						trigger: true,
						replace: true,
					});
				} else {
					Backbone.history.start(start_params);
				}
			}, this);
		},

		getOrCreateBookCtrl: function (book_id) {
			var book_ctrl = this.book_controllers[book_id];
			if (book_ctrl) {
				return book_ctrl;
			}

			var book = this.master_model.get("books").getOrCreate(book_id);
			var root_url = EbkUrlMain.getRoot() + book.get("store_sku") + "/";
			book_ctrl = new EbkBookCtrl({
				book_model: book,
				root_url: root_url,
			});

			this.listenTo(book_ctrl, "breadcrumbs", function (suffix) {
				this.page.setBreadcrumbs(
					[
						{text: "Bookstore", url: "/store", no_stay: true},
						{text: "My books", url: EbkUrlMain.getUrl("index")},
						{
							text: book.get("short_title"),
							url: EbkUrlMain.getUrl("book", book.get("store_sku"), ""),
						},
					].concat(suffix),
					"data-ebk-stay"
				);
				document.title =
					suffix[suffix.length - 1].text + " - Art of Problem Solving";
			});

			this.listenTo(book_ctrl, "replace_url", function (url) {
				this.navigateRoot(root_url + url, {
					trigger: false,
					replace: true,
				});
			});

			this.listenTo(book_ctrl, "show_section", function (section) {
				if (!section || !Feed) {
					return;
				}
				var feed_data = section.getFeedData(book_ctrl.url_table);
				Feed.setPageFeed(
					feed_data.category_id,
					feed_data.main_url,
					feed_data.subtitle
				);
			});

			this.listenTo(book_ctrl, "force_out_of_book", function () {
				this.navigateRoot(EbkUrlMain.getUrl("index"), {
					trigger: true,
					replace: true,
				});
			});

			this.book_controllers[book_id] = book_ctrl;
			return book_ctrl;
		},

		// Helper for showing the store sidebar element
		showSidebar: function () {
			this.page.showElement(this.store_sidebar_el);
			$("#main-content").addClass("left-navigation");
			$("#submenu-icon").css("display", "");
		},

		// Wrapper around Page.js clearPage that does some other things that need
		// doing on every clearPage.
		// -- Remove fullscreen class.
		// -- Reset left menu.
		// -- Mark that the view inside a section for a book is no longer shown.
		clearPage: function () {
			if ($("body").hasClass("fullscreen")) {
				$("body").removeClass("fullscreen");
				$(window).trigger("resize");
			}

			$("#main-content").removeClass("left-navigation");
			$("#submenu-icon").hide();
			this.viewed_book = null;
			this.page.clearPage();
		},

		//
		// BEGIN ROUTES
		//

		routeIndex: function () {
			this.page.setBreadcrumbs(
				[{text: "Bookstore", url: "/store", no_stay: true}, {text: "My Books"}],
				"data-ebk-stay"
			);
			document.title = "My Books - Art of Problem Solving";

			this.clearPage();

			this.showSidebar();
			this.page.showLoader();

			var master = this.master_model;
			master.requestLoad(function (ok, data) {
				if (!ok) {
					return this.routeError(data);
				}

				this.clearPage();
				this.showSidebar();

				if (!AoPS.session.logged_in) {
					alert("You are not logged in. Please log in to view your books.");
					return;
				}
				if (master.getAccessibleBooks().length) {
					if (!AoPS.session.initialized) {
						AoPS.Initialize.display();
					} else {
						this.page.showElement({
							id: "ebk-index",
							location: "ebk-loc-index",
							constructor: function () {
								return new EbkVIndex.Main({model: master});
							},
						});
					}
				} else {
					window.location = "/store/online";
				}
			}, this);
		},

		routeBook: function (book_sku, url_fragment, details) {
			var book_id = this.master_model.getBookIdFromSku(book_sku);
			if (!book_id) {
				return this.route404();
			}
			if (!AoPS.session.logged_in) {
				alert("You are not logged in. Please log in to view your book.");
				return;
			}
			if (!AoPS.session.initialized) {
				this.clearPage();
				AoPS.Initialize.display({escapable: false});
				return;
			}

			var book_ctrl = this.getOrCreateBookCtrl(book_id);
			this.master_model.get("books").getOrCreate(book_id);

			// Only clear the page if the book is not on the page.
			if (!this.viewed_book || this.viewed_book !== book_id) {
				this.clearPage();
				this.page.setBreadcrumbs(null); // Until loading is done
				this.page.showElement({
					id: "ebk-book-" + book_id,
					location: "ebk-loc-book",
					constructor: function () {
						return book_ctrl.view;
					},
				});
				this.viewed_book = book_id;
			}

			// Book controller manages setting the page feed. Doing this one first
			// results in inconsistencies so we don't do it.
			// Feed && Feed.setPageFeed(book.get('cmty_category_id'));
			book_ctrl.processUrl(url_fragment, details);
		},

		routeBookPreview: function (book_sku) {
			var book_id = this.master_model.getBookIdFromSku(book_sku);
			if (!book_id) {
				return this.route404();
			}
			var book = this.master_model.get("books").getOrCreate(book_id);

			this.clearPage();
			this.page.showElement({
				id: "ebk-free-preview-" + book_id,
				location: "ebk-loc-book",
				constructor: function () {
					return new EbkVBook.FreePreviewMain({model: book});
				},
			});

			var store_url = "/store/book/" + book.get("store_sku");
			this.page.setBreadcrumbs(
				[
					{text: "Bookstore", url: "/store", no_stay: true},
					{text: "Online Books", url: "/store/online", no_stay: true},
					{
						text: book.get("title") + " Online Book",
						url: store_url,
						no_stay: true,
					},
					{text: "Sample"},
				],
				"data-ebk-stay"
			);
			document.title = "Sample - Art of Problem Solving";
		},

		routeEdge: function (book_sku, section_code) {
			var EbkAdmin = AoPS.Ebooks.Admin;
			var route_ok =
				EbkAdmin && EbkAdmin.routeEdge(this, book_sku, section_code);
			if (!route_ok) {
				this.navigateRoot(EbkUrlMain.getUrl("index"), {
					trigger: true,
					replace: true,
				});
			}
		},

		route404: function () {
			this.clearPage();
			this.page.setBreadcrumbs(
				[
					{text: "Bookstore", url: "/store", no_stay: true},
					{text: "My books", url: "/ebooks/"},
					{text: "Not Found"},
				],
				"data-ebk-stay"
			);
			document.title = "Not Found - Art of Problem Solving";

			var html =
				'<div class="error-box">' +
				"<p>The URL you went to, " +
				window.location.href +
				", is not valid.</p>" +
				'<p>Click <a href="/ebooks/" data-ebk-stay>here</a> if you want ' +
				"to return to the index.</p>" +
				"</div>";
			this.page.throwError({
				error_type: "custom",
				error_msg: html,
			});
		},
	});

	$(window).on("load", function () {
		var router = new Ebooks.Router();
		$("#main-content").append(router.page.$el);
		AoPS.Ebooks.master_model = router.master_model;
		router.startHistory(USE_PUSH_STATE);

		if (/file/.test(window.location.protocol)) {
			$("body").html(" ");
		}
	});

	return Ebooks;
})(AoPS.Ebooks);
